import type { BatchOrigin, RunOriginStatus } from "@/types/batches.types";

/**
 * Spec 084 — a origem em TEXTO.
 *
 * "Desfeita" é o caso que se esquece: a importação que criou a batelada de origem foi revertida, a
 * ligação virou nula e só o rótulo congelado sobrou. Mostrar o rótulo sem dizer que ele não aponta
 * mais para nada faria a herdeira parecer rastreada quando a rastreabilidade se perdeu.
 */
export function originsLabel(origins: BatchOrigin[]): string {
  if (origins.length === 0) return "nenhuma";
  return origins.map((o) => (o.runId ? o.label : `${o.label} (desfeita)`)).join(", ");
}

/** O estado da origem, sempre com rótulo — nunca só cor (design system). */
export function originStatusLabel(status: RunOriginStatus | null): string | null {
  if (status === "PENDING") return "Origem pendente";
  if (status === "NONE") return "Sem origem";
  if (status === "CONFIRMED") return "Origem confirmada";
  return null;
}
